/**
 * Default API endpoint for Fluid API
 */
const DEFAULT_API_ENDPOINT = "https://api.fluid.app";

// Store custom API endpoint
let customApiEndpoint: string | null = null;

// Define window with our custom property
declare global {
  interface Window {
    __FLUID_API_BASE_URL?: string;
  }
}

/**
 * Set a custom API endpoint
 * @param endpoint - The custom API endpoint URL
 */
export function setApiEndpoint(endpoint: string): void {
  customApiEndpoint = endpoint;

  // Also set it on the window object for the axios interceptor to use
  if (typeof window !== "undefined") {
    window.__FLUID_API_BASE_URL = endpoint;
  }
}

/**
 * Get the API endpoint
 * @returns The API endpoint URL (custom if set, otherwise default)
 */
export function getApiEndpoint(): string {
  return customApiEndpoint ?? DEFAULT_API_ENDPOINT;
}
